import ITrackingObject from '@/interfaces/tracking-object.interface';
import { store } from '@/store/store';
import globals from '@/utils/globals';
import { Action } from '@studyportals/datalake-event-tracker';
import { Ref, ref, computed } from 'vue';

export default class OverviewWrapper {
	public visible: Ref<boolean> = ref(false);

	private studyId = computed((): number | null => {
		return store.getters.activeStudyId();
	});

	public showOverview(): void {
		if (!this.visible.value) {
			this.visible.value = true;

			document.dispatchEvent(
				new CustomEvent('bestfit_overview_opened', {
					detail: {
						studyId: this.studyId,
					},
				}),
			);
		}

		this.trackIncentiveClick();
	}

	private trackIncentiveClick(): void {
		const trackingParams: ITrackingObject = {
			action: Action.IMPRESSION,
			label: 'overview',
			property: String(this.studyId.value),
		};

		globals.bestFitTracking.snowPlow(trackingParams);
	}
}
